<!-- =========================================================================================
  File Name: UserEditTabInformation.vue
  Description: User Edit Information Tab content
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div id="user-edit-tab-info">
    <div class="vx-row">
      <div class="vx-col w-full md:w-1/1">
      <div class="vx-row" v-if="Role==1">
        <div class="vx-col md:w-1/3 w-full mt-2">
          <label>Code <span class="rqrd">*</span></label>
          <vs-input class="inputx w-full" name="Code" v-model="Code" v-validate="'required'"/>
          <span class="text-danger text-sm"  v-show="errors.has('Code')">{{ errors.first('Code') }}</span>
        </div>
        <div class="vx-col md:w-1/3 w-full mt-2">
          <label>Name <span class="rqrd">*</span></label>
          <vs-input class="inputx w-full" name="Name" v-model="Name" v-validate="'required'"/>
          <span class="text-danger text-sm"  v-show="errors.has('Name')">{{ errors.first('Name') }}</span>
        </div>
        <div class="vx-col md:w-1/3 w-full mt-2">
          <vs-button class=" mt-5" @click="before_save" :disabled="!validateForm">Save</vs-button>
        </div>
      </div>

        <div class="vx-row">
        <div class="vx-col sm:w-1/2 w-full mt-4">
          <vs-list>
            <vs-list-header title="Available Short Codes" color="primary"></vs-list-header>
              <vs-list-item v-for="(listItem, index) in ShortCodes" :key="index" :title="listItem.Code">
              - {{listItem.Name}}
              </vs-list-item>
          </vs-list>
        </div>
        </div>


      </div>

    </div>

  </div>
</template>

<script>
import flatPickr from 'vue-flatpickr-component'
import 'flatpickr/dist/flatpickr.css'
import vSelect from 'vue-select'
import ls from "@/common/localStorage"

export default {
  components: {
    vSelect,
    flatPickr
  },
  props: {
    data: {
      type: Array,
      required: true
    }
  },
  data () {
    return {
      ShortCodes: this.data,
      Role: ls.getSessionValueByKey("Role"),
      Name: null,
      Code: null
    }
  },
  computed: {
    validateForm () {
      return !this.errors.any()
    }
  },
  methods: {
    before_save()
    {
       this.$validator.validateAll().then(result => {
        if(result) {
          // if form have no errors
          this.save_changes();
        }
      })
    },
    save_changes () {
      /* eslint-disable */
      if (!this.validateForm) return
        let data = {
          Code: this.Code,
          Name: this.Name
        }
      this.$vs.loading()
    this.$store.dispatch('mailtplManagement/updateShortCode', { data: data})
          .then(res => { 
            //alert(res.message)          
            this.$vs.notify({
              color: 'success',
              position: 'top-center',
              title: 'Short Code',
              text: res.message
            })
            this.ShortCodes.push(data)
            this.Code = ''
            this.Name = ''
            this.$vs.loading.close()  
          })
    },
    reset_data () {
      this.data_local = Object.assign({}, this.data)
    }
  }
}
</script>
